import { fetcher } from '../utils'

export default async (): Promise<void> => fetcher(`/api/notification/native/push/unsubscribe`, 'DELETE', undefined)
